const previewHosts = new Set(['[::1]', '127.0.0.1', 'dev.nitrogenx.co', 'localhost', 'nitrogenx.co', 'www.nitrogenx.co']);

export const isTwasHost = (hostname: string, pathname: string): boolean => (
  hostname === 'twas.nitrogenx.co' || hostname === 'www.twas.nitrogenx.co' ||
  (previewHosts.has(hostname) && (pathname === '/twas' || pathname.startsWith('/twas/')))
);
